const React = require('react');
const PropTypes = require('prop-types');
const sortBy = require('lodash/sortBy');
const last = require('lodash/last');
const emit = require('emmy/emit');

const QuizView = require('./view');
const { STATUSES } = require('./consts');
const {
  QUIZ_TYPES,
  getResultForTopScoreQuiz,
} = require('../utils');

class Quiz extends React.PureComponent {
  constructor(...args) {
    super(...args);

    document.body.addEventListener('test-start', () => this.setState({
      status: STATUSES.inProgress,
    }));

    this.state = {
      status: STATUSES.start,
      currentQuestion: 0,
      givenAnswers: {},
      resultId: new URLSearchParams(new URL(window.location).search).get('result')
    };
  }

  getResult() {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.config.quizType === QUIZ_TYPES.personal) {
      return this.getResultForPersonalQuiz();
    }
    if (this.state.resultId) {
        const result = this.props.config.results.find(item => item.id === Number(this.state.resultId));
        if (result) {
            return getResultForTopScoreQuiz(
                // eslint-disable-next-line react/destructuring-assignment
                this.props.config.results,
                // eslint-disable-next-line react/destructuring-assignment
                this.props.config.questions,
                result.score,
            );
        }
    }
    // eslint-disable-next-line react/destructuring-assignment
    const score = this.props.config.questions.map((question, index) => (
      // eslint-disable-next-line react/destructuring-assignment
      question.answers[this.state.givenAnswers[index]].score._default || 0
    )).reduce((acc, cur) => acc + Number(cur), 0);
    return getResultForTopScoreQuiz(
      // eslint-disable-next-line react/destructuring-assignment
      this.props.config.results,
      // eslint-disable-next-line react/destructuring-assignment
      this.props.config.questions,
      score,
    );
  }

  getResultForPersonalQuiz() {
     if (this.state.resultId) {
        const result = this.props.config.results.find(item => item.id === Number(this.state.resultId));
        if (result) {
            return result;
        }
    }
    // eslint-disable-next-line react/destructuring-assignment
    const resultsWithSums = this.props.config.results.map((result) => {
      // eslint-disable-next-line react/destructuring-assignment
      const sum = this.props.config.questions.map((question, index) => (
        // eslint-disable-next-line react/destructuring-assignment
        question.answers[this.state.givenAnswers[index]].score[result.name] || 0
      )).reduce((acc, cur) => acc + Number(cur), 0);
      return { ...result, sum };
    });

    return last(sortBy(resultsWithSums, ['sum']));
  }

  giveAnswer(questionIndex, answerIndex) {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.givenAnswers[questionIndex]) {
      // already voted
      return;
    }

    this.setState({
      givenAnswers: {
        // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
        ...this.state.givenAnswers,
        [questionIndex]: answerIndex,
      },
    });

    // eslint-disable-next-line operator-linebreak
    const haveToLingerOnCurrentSlide =
      // have to show comment
    // eslint-disable-next-line react/destructuring-assignment
      this.props.config.questions[questionIndex].answers[answerIndex].comment
      // have to show correct answer
      // eslint-disable-next-line react/destructuring-assignment
      || !!this.props.config.hasCorrectAnswers;

    if (!haveToLingerOnCurrentSlide) {
      this.goToNextQuestion();
    }
  }

  goToNextQuestion() {
    // eslint-disable-next-line react/destructuring-assignment
    const nextIndex = this.state.currentQuestion + 1;
    // eslint-disable-next-line react/destructuring-assignment
    if (nextIndex === this.props.config.questions.length) {
      emit(document.body, 'test-finish', null, true);
      this.setState({
        status: STATUSES.finished,
      });
    } else {
      emit(document.body, 'test-next', null, true);
      this.setState({
        currentQuestion: nextIndex,
      });
    }
  }

  refreshQuiz() {
    emit(document.body, 'test-again', null, true);
    window.history.replaceState(null, '', window.location.pathname + window.location.search.replace(/[\?&]result=[^&]+/, '').replace(/^&/, '?'));
    this.setState({
      status: STATUSES.inProgress,
      currentQuestion: 0,
      givenAnswers: {},
      resultId: null,
    });
  }

  // eslint-disable
  render() {
    if (this.state.resultId && this.state.status !== STATUSES.inProgress){
        this.state.status = STATUSES.finished;
    }

    return (
      <QuizView
        status={this.state.status}
        questions={this.state.questions}
        currentQuestion={this.state.currentQuestion}
        givenAnswers={this.state.givenAnswers}
        config={this.props.config}
        giveAnswer={(...args) => this.giveAnswer(...args)}
        goToNextQuestion={() => this.goToNextQuestion()}
        getResult={() => this.getResult()}
        refreshQuiz={() => this.refreshQuiz()}
      />
    );
  }
}

Quiz.propTypes = {
  config: PropTypes.object.isRequired,
};

module.exports = Quiz;
